import React, { useEffect } from "react";
import { Tag } from "lucide-react";
import { useValidateCoupon } from "../../hooks/useValidateCoupon";
import CouponInput from "../modal/cart/CouponInput";

export default function CouponSection({
  subtotalPrice,
  freight,
  deliveryType,
  couponData,
  setCouponData,
  discountValue,
  setDiscountValue,
}) {
  const {
    loading: couponLoading,
    error: couponError,
    couponData: validatedCoupon,
    validateCoupon,
    clearCoupon,
    calculateDiscount,
  } = useValidateCoupon();

  // Recalcula desconto quando o subtotal mudar (e há um cupom aplicado)
  useEffect(() => {
    if (couponData && couponData.valid) {
      // Calcula desconto APENAS sobre o subtotal dos produtos
      const { discount_type, discount_value } = couponData;
      let discount = 0;
      if (discount_type === "percentage") {
        discount = (subtotalPrice * discount_value) / 100;
      } else if (discount_type === "fixed") {
        discount = Math.min(discount_value, subtotalPrice);
      }

      setDiscountValue(discount);
    }
  }, [subtotalPrice, couponData, setDiscountValue]);

  // Atualiza couponData e discountValue quando o cupom for validado
  const handleValidate = async (code) => {
    const result = await validateCoupon(code);
    if (result && result.valid) {
      setCouponData(result);

      // Calcula desconto APENAS sobre o subtotal dos produtos
      const { discount_type, discount_value } = result;
      let discount = 0;
      if (discount_type === "percentage") {
        discount = (subtotalPrice * discount_value) / 100;
      } else if (discount_type === "fixed") {
        discount = Math.min(discount_value, subtotalPrice);
      }

      setDiscountValue(discount);
    }
    return result;
  };

  // Limpa cupom
  const handleClear = () => {
    clearCoupon();
    setCouponData(null);
    setDiscountValue(0);
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-4 sm:p-6">
      <h2 className="text-lg sm:text-xl font-bold text-gray-900 flex items-center gap-2 mb-4">
        <Tag className="w-5 h-5 sm:w-6 sm:h-6 text-brand-primary" />
        Cupom de Desconto
      </h2>

      <CouponInput
        onValidate={handleValidate}
        onClear={handleClear}
        loading={couponLoading}
        error={couponError}
        couponData={couponData || validatedCoupon}
        totalValue={subtotalPrice}
        discountValue={discountValue}
      />
    </div>
  );
}
